import { render } from "./LandscapeMode.vue?vue&type=template&id=2291dd25&scoped=true"
const script = {}

import "./LandscapeMode.vue?vue&type=style&index=0&id=2291dd25&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2291dd25"]])

export default __exports__